// extracted by mini-css-extract-plugin
module.exports = {"Puzzle":"Puzzle_Puzzle__3v8O2","Word":"Puzzle_Word__bntfK"};